import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"background-color-fh",attrs:{"fluid":"","id":"footer"}},[_c(VFooter,{staticClass:"font-weight-light background-color-fh"},[_c(VCol,{staticClass:"text-center"},[_c('strong',[_vm._v(_vm._s(new Date().getFullYear())+" - Maxim Betin - Copyright @ All Rights Reserved")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }